import React from 'react';
import { IoMdClose } from 'react-icons/io';
import { MdDeleteOutline } from 'react-icons/md';

const ConfirmDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
  isDeleting
}) => {
  if (!isOpen) return null;

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center">
      <div
        onClick={onClose}
        className="fixed inset-0 backdrop-blur-[4px] bg-black/20"
      />
      <div className="z-20 relative bg-white rounded-[20px] p-6 w-full max-w-[420px] mx-5 shadow-[0px_4px_6px_0px_#0000001A]">
        <div className="flex justify-between items-start">
          <div className="size-12 rounded-full bg-red-50 grid place-items-center">
            <MdDeleteOutline size={24} className="text-[#E6483D]" />
          </div>
          <button
            onClick={onClose}
            className="size-7 border border-[#D9D9D9] rounded-[6px] grid place-items-center cursor-pointer"
          >
            <IoMdClose color="#666666" size={20} />
          </button>
        </div>

        <div className="mt-4">
          <h3 className="text-lg font-semibold text-[#14151A]">
            Delete Recipe Group
          </h3>
          <p className="text-sm text-[#7C8091] mt-2">
            Are you sure you want to delete{' '}
            <span className="font-medium text-[#14151A]">"{itemName}"</span>? This
            action cannot be undone.
          </p>
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="flex-1 py-2.5 rounded-[8px] border border-[#E7E7E9] text-[#14151A] font-medium text-sm hover:bg-gray-50 transition-colors disabled:opacity-45"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="flex-1 py-2.5 rounded-[8px] bg-[#E6483D] text-white font-medium text-sm hover:bg-red-600 transition-colors disabled:opacity-45"
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
